import React, {useState } from 'react';
import StartFirebase from './Firebase';
import { dataRef } from "./Firebase";
import '../Pract.css';
import '../assets/assets.css';
import { ref, onValue } from 'firebase/database';
import Table from 'react-bootstrap';
import WedFilm from '../assets/WedFilm.mp4';
import AdFilm from '../assets/AdFilm.mp4';
import Musical from '../assets/Musical.mp4';



const Portfolio = ()=>{


    return(
        <>
        <div className='portfolio-container'>
            <div className='section-title1'>PortFolio</div>
        
            <div className='portfolio-div'>
                <div className='portfolio-frame'>
                    <div className="portfolio-div1">Wedding Show</div>
                    <div className="portfolio-div2"><video src={WedFilm} controls/></div>
                    <div className="portfolio-div3"></div>
                </div>
                <div className='portfolio-frame'>
                    <div className="portfolio-div1">Ad-Filming</div>
                    <div className="portfolio-div2"><video src={AdFilm} controls/></div>
                    <div className="portfolio-div3"></div>                    
                </div>
                <div className='portfolio-frame'>
                    <div className="portfolio-div1">Musical Album : Uska hi Banana </div>
                    <div className="portfolio-div2"><video src={Musical} controls/></div>
                    <div className="portfolio-div3"></div>                    
                </div>

            </div>
        </div>
        </>
    );
}

export default Portfolio;